export function loadUsercentrics(settingsId) {
  return new Promise((resolve, reject) => {
    if (!settingsId) return reject('No settingsId provided');
    if (document.getElementById('usercentrics-cmp'))
      return resolve(window.Usercentrics);

    const script = document.createElement('script');
    script.id = 'usercentrics-cmp';
    script.async = true;
    script.setAttribute('data-settings-id', settingsId);
    script.src = 'https://app.usercentrics.eu/browser-ui/latest/loader.js';

    script.onload = () => {
      const checkReady = setInterval(() => {
        if (window.Usercentrics?.ready) {
          clearInterval(checkReady);
          resolve(window.Usercentrics);
        }
      }, 100);
    };

    script.onerror = () => reject('Failed to load Usercentrics script');
    document.head.appendChild(script);
  });
}
